import { SS_SWITCH_CONFIG } from '../../common/domain/constants';
import { MODALS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';

class SocialSecurityController {
  constructor(socialSecurityService, socialSecurityDataService, $log, $state) {
    'ngInject';
    this.socialSecurityService = socialSecurityService;
    this.socialSecurityDataService = socialSecurityDataService;
    this.log = $log;
    this.state = $state;

    this.socialSecurityService.initData();
  }

  $onInit() {
    this.employeeId = this.socialSecurityService.employeeId;
    this._loadData();
  }

  get modal() {
    return $(MODALS.SOCIAL_SECURITY_MODAL);
  }

  openModal () {
    this.modal.modal('show');
  }

  closeModal() {
    this.modal.modal('hide');
  }

  _loadData() {
    this.socialSecurityDataService
      .getQuoteBasisInitial(this.employeeId)
      .then((response) => {
        this.log.info('socialSecurityDataService.getQuoteBasisInitial', response.data);
        this.ssData = response.data.quoteBasisList;
        this.employeeData = response.data.quoteBasisProfile;
      })
      .catch((error) => {
        this.log.error(error);
        // TODO: [Manu] revisar esto, no debería hacer falta con errorInterceptor, no falla como en APP Ayuda Alimentaria pq en el routing de loans se hace esta misma llamada pero sin el state.go error
        this.state.go(STATES.ERROR);
      });
  }

  showHeaderEmployee() {
    return this.employeeData && this.employeeData.idIdentification && this.employeeData.nameInicials && this.employeeData.socialSecurityMembershipNumber;
  }

  searchPeriod($event) {
    if (!$event) {
      this._loadData();
      return;
    }

    const isContribution = $event.data.periodType == SS_SWITCH_CONFIG[0].value;

    isContribution ? this.searchContribution($event.data) : this.searchSettlement($event.data);
  }

  searchContribution(data) {
    this.socialSecurityDataService
      .getContributions(this.employeeId,data.year,data.month)
      .then((response) => {
        this.ssData = response.data.quoteBasisList;
      })
      .catch((error) => {
        this.errorMessage = error.data.message;
        this.openModal();
        this.log.error(error);
      });
  }

  searchSettlement(data) {
    this.socialSecurityDataService
      .getSettlements(this.employeeId,data.year,data.month)
      .then((response) => {
        this.ssData = response.data.quoteBasisList;
      })
      .catch((error) => {
        this.errorMessage = error.data.message;
        this.openModal();
        this.log.error(error);
      });
  }
}

export default SocialSecurityController;



// WEBPACK FOOTER //
// ./client/app/social-security.module/features/socialSecurity/socialSecurity.controller.js